// resume page/component
import { useContext, useEffect, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { useForm, useFieldArray, watch } from "react-hook-form";
import { useParams, useNavigate } from "react-router-dom";
import axios from 'axios';

import StateContext from '../stateContext';

import format1 from './imgs/sampleResumeFormat1.png';
import format2 from './imgs/sampleResumeFormat2.png';

const imageArr = [format1, format2];

function FormatSelector() {

  const navigate = useNavigate();
  const { appID } = useParams();
  const { userInfo, createNotification, setUserInfo } = useContext(StateContext);
  
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    values: {
      default_resume_format: String(userInfo.default_resume_format)
    }
  });

  const default_resume_format = watch("default_resume_format");

  async function setDefaultResume(selectedFormat) {

    // set csrf tokens
    axios.defaults.xsrfCookieName = 'csrftoken';
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.withCredentials = true;

    // update default resume
    axios.patch(
      '/api/account/update',
      {
        "email": userInfo.email,
        "jwt": userInfo.jwt,
        "profileUpdate": {default_resume_format: Number(selectedFormat.default_resume_format)}
      }
    ).then((response) => {
      if (response.status == 200 && response.data.success == true && response.data.results > 0) {
        // update default resume format
        setUserInfo({
          ...userInfo,
          "default_resume_format": default_resume_format
        })

        if (appID) {
          navigate(`/resume/${appID}`)
        } else {
          navigate('/applications/all')
        }
          
      } else {
        // prompt error 
        createNotification({
          "status": "error",
          "msg": "Error fetching user profile",
        })
      }

      return { selectedFormat: 1 };
    })
  }

  return (
    <main
      style={{
        display: "flex", flexDirection: "column", overflowX: "hidden", overflowY: "hidden", gap: "10px"
      }}
    >
      <h2>Which resume format works best?</h2>
      <form
        onSubmit={handleSubmit(setDefaultResume)}
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          height: "100%"
        }}
      > 
        <section
          className="defaulResumeList"
          style={{
            
          }}
        >
          { imageArr.map((image, index) => {

            return (
              <label
                key={`format-${index}`}
                style={{
                  border: "2px solid black",
                  width: "calc(100% - 4px)",
                  height: "fit-content",
                  position: "relative"
                }}
              >
                <img src={image}
                  style={{
                    objectFit: "init",
                    
                  }}
                />
                <input 
                type="radio" 
                // 1. Keep only ONE value prop. It must compute to a number since you use valueAsNumber.
                value={index + 1} 
                
                style={{
                  position: "absolute", 
                  zIndex: 1,
                  right: "10px",
                  top: "10px"
                }}
                
                // 2. Put register LAST so React Hook Form can control the value and checked states
                {...register("default_resume_format", { required: true, valueAsNumber: true })}
                />
                <span
                style={{
                  position: "absolute",
                  left: "10px",
                  bottom: "10px",
                  fontWeight: "bold"
                }}
                >
                  Format {index + 1}
                </span>
              </label>
            )
          })}
        </section>
        <button 
        className='next' type="submit"
        style={{marginBottom: "80px"}}
        >Set default resume</button>
      </form>
    </main>
  )
}

export default FormatSelector;